// CONSTANTS are all caps.
const NS = 'VideoAndTextBlock';
const CLS = 'videoTextBlock';
const BLK = '.' + CLS + '-';

export class VideoAndTextBlock {
	constructor($el) {
		// $el is the blk node return by the loadVideoFeature function
		this.$el = $el;
		this.enterViewPort = false;
		this.img = $(this.$el).find('.videoTextBlock-thumbnail')[0];
	}

	init() {
		this.controlsVideo();
		this.imageClick();
	}

	controlsVideo() {
		let enterViewPort = this.enterViewPort;
		let video = $(this.$el).find('video')[0];
		let autoPlay = video.getAttribute('data-autoplay');
		if (autoPlay === 'off' || autoPlay === 'video_audio') {
			video.setAttribute('controls', true);
		}
		if (autoPlay === 'video_only' || autoPlay === 'video_audio') {
			let playPromise = video.play();
			if (playPromise !== undefined) {
				playPromise.then((_) => {
					let observer = new IntersectionObserver((entries) => {
						entries.forEach((entry) => {
							if (entry.intersectionRatio !== 1 && !video.paused && !enterViewPort) {
								video.pause();
							} else if (video.paused) {
								if (this.img) {
									$(this.img).addClass('d-none');
									$(video).removeClass('d-none');
								}
								video.play();
								enterViewPort = true;
							}
						});
					},
					{threshold: 0.75});
					if (this.img) {
						observer.observe(this.img);
					} else {
						observer.observe(video);
					}
				});
			}
		}
	}

	imageClick() {
		let $block = $(this.$el);
		let video = $block.find('video')[0];
		$(this.img).on('click', () => {
			$(this.img).addClass('d-none');
			$(video).removeClass('d-none');
			video.play();
			video.muted = false;
		});
	}
}



// WEBPACK FOOTER //
// D:/AzureDevops/vsts-agent-win-x64-2.202.1_04/_work/396/s/FrontEnd/src/views/blocks/videoAndTextBlock/js/videoAndTextBlock.js